import * as Func from '../../../../../../../helpers/functions';

import { Button, Icon } from "antd";
import { DATE_TIME_FORMAT, DETAIL_ACTIONS } from "constants/Define";
import { ListComponent, StatusComponent } from "containers/backend/common/component/Index";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import PriceConfigDetail from "./PriceConfigDetail";
import Ripple from "containers/backend/common/component/Ripple";
import Wrapper from "containers/backend/common/component/Wrapper";
import action from '../../../../../../../actions/index';
import moment from "moment";
import { omit } from "lodash";
import { useTranslation } from "react-i18next";

const PriceConfig = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [visible, setVisiblePrice] = useState(false);
    const [priceConfig, setPriceConfig] = useState({});
    const [actionType, setActionType] = useState('');

    const roomTypeState = useSelector(state => state.roomTypeReducer);
    const rateState = useSelector(state => state.rateReducer);

    useEffect(() => {
        const filters = {
            hotelId: props.hotelId,
            ratePlanId: props.ratePlanId,
            pageIndex: 1,
            pageSize: 1000
        }
        dispatch(action.getListRoomTypes(omit(filters, ['ratePlanId'])))
        dispatch(action.getPriceConfigBeachVilla(omit(filters, ['pageIndex', 'pageSize'])))
    }, [])

    const listCols = ['startDate', 'endDate', 'roomtype', 'point', 'isActive'];
    const modelOrderItem = rateState.priceConfig.length > 0 ? Object.keys(rateState.priceConfig[0]) : [];
    
    const handleToCreate = () => {
        setVisiblePrice(true)
        setPriceConfig({})
        setActionType(DETAIL_ACTIONS.CREATE)
    }

    const handleToUpdate = (data) => {
        setVisiblePrice(true)
        setPriceConfig(data)
        setActionType(DETAIL_ACTIONS.UPDATE)
    }

    const componentTable = {
        startDate: {
            render: (startDate) => {
                return moment(startDate).format(DATE_TIME_FORMAT.SHORT_DATE)
            }
        },
        endDate: {
            render: (endDate) => {
                return moment(endDate).format(DATE_TIME_FORMAT.SHORT_DATE)
            }
        },
        roomtype: {
            render: (roomTypeInfos, record) => {
                return record.roomTypeInfos.map(item => item.code).join(', ')
            }
        },
        point: {
            width: 130,
            render: (point) => {
                return point
            }
        },
        isActive: {
            width: 160,
            key: 'isActive',
            render: (isActive) => {
                return <StatusComponent color={isActive ? 'green' : 'red'}
                    label={isActive ? t('item.hotel.active') : t('item.hotel.deActive')}
                />
            }
        },
        action: {
            width: 80,
            align: 'center',
            key: 'action',
            fixed: 'right',
            render: (text, record) => {
                return (
                    <Wrapper>
                        <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                            <Button
                                onClick={() => handleToUpdate(record)}
                                style={{border: 'none'}}
                            >
                                <Icon type="form" className="fs20" />
                            </Button>
                        </Ripple>
                    </Wrapper>
                )
            },
        }
    };

    return (
        <Wrapper>
            <Wrapper>
                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                    <Button
                        onClick={handleToCreate}
                        className='btn btn-primary'
                    >
                        + {t(`action.create`)}
                    </Button>
                </Ripple>
            </Wrapper>
            <PriceConfigDetail
                visible={visible}
                setVisiblePrice={setVisiblePrice}
                priceConfig={priceConfig}
                setPriceConfig={setPriceConfig}
                roomTypeList={roomTypeState.dataList}
                actionType={actionType}
                hotelId={props.hotelId}
                ratePlanId={props.ratePlanId}
            />
            <ListComponent
                tableKey="price-config-list"
                scroll={{ x: 700 }}
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                dataSource={Func.getDataSource(rateState?.priceConfig || [], modelOrderItem)}
                columns={Func.columnsTable({
                    titleTable: Func.getTitleTable(listCols, ['action'], []),
                    component: componentTable,
                    itemName: 'rate.priceConfig'
                })}
                componentTableList={{}}
            />
        </Wrapper>
    );
};

export default PriceConfig;
